import { getIconClassName } from '@uifabric/styling';
import { MiniIcons } from 'owa-mini-icons';
import { showToast } from 'mini-toast';
const classNames = require('classnames/bind');

export function showToastWithErrorMsg(errorMessage: string) {
    const icon: string = classNames('ms-Icon', getIconClassName(MiniIcons.Info));
    showToast({ label: errorMessage, icon });
}
